var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavbarChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 31.167 31.167"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "M20.851 15.906a1.7 1.7 0 111.7 1.7 1.7 1.7 0 01-1.7-1.7zm-6.624 0a1.7 1.7 0 111.7 1.7 1.7 1.7 0 01-1.7-1.7zm-6.626 0a1.7 1.7 0 111.7 1.7 1.7 1.7 0 01-1.7-1.7z",
    fill: "#a28d50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 7",
    d: "M15.613 1A14.592 14.592 0 001 15.605a15.435 15.435 0 001.969 7.287 1.532 1.532 0 01.1 1.316l-.977 3.272a.91.91 0 001.2 1.138l2.946-.875a2.474 2.474 0 012.173.526A14.579 14.579 0 1015.613 1z",
    fill: "none",
    stroke: "#7e7e7e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}

export default SvgNavbarChat;